<template lang="pug">
.createReturnLabel
  .container
    .row
      .col-12
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.m-0.font-weight-bold.text-primary() Create Return Label
            i.closeForm.nav-item.fas.fa-fw.fa-times( v-on:click="closeModal()")
          .card-body            
            .col-12(v-if="loading")
              .col-12
                Spinner
            form.col-12(v-if="!loading" v-on:submit.prevent="createReturnLabel")
              .col-12(v-show="creatingLabel")
                p Creating Return Label.  This may take some time.
                Spinner                
              .col-12
                p <b>Note:</b> You can only create domestic return labels.  International return labels are not supported at this time. 
                label Where is this return shipment going to?
                br
                select(v-model="address" required)
                  option(selected="true" disabled value="") Please select an address
                  option(v-for="address in addresses" v-bind:value="address") {{address.name}}
              .col-12
                label Shipping Carrier Account
                br
                select(v-model="carrier" required)
                  option(selected="true" disabled value="") Please select a carrier
                  option(v-for="carrier in allCarriers" v-bind:value="carrier._id") {{carrier.type}} - {{carrier.accountNumber}}
              .col-12(v-if="address.countryCode == 'US'")
                label Weight (lbs)
                br
                input(required type="number" step=".0001" min="0" v-model="order.lbsWeight")
              .col-12(v-else)
                label Weight (kg)
                br
                input(required type="number" step=".0001" min="0" v-model="order.kgWeight")
              .col-12(v-if="address.countryCode =='US'")
                .row
                  .col-12
                    strong Package Dimensions (inches)
                    br
                    label Length
                    br
                    input(required type="number" step=".0001" min="0" v-model="dimensions.packageLength")
                  .col-12
                    label Width
                    br
                    input(required type="number" step=".0001" min="0" v-model="dimensions.packageWidth")
                  .col-12
                    label Height
                    br
                    input(required type="number" step=".0001" min="0" v-model="dimensions.packageHeight")
              .col-12(v-else)
                .row
                  .col-12
                    strong Package Dimensions (cm)
                    br
                    label Length
                    br
                    input(required type="number" step=".0001" min="0" v-model="dimensions.cmPackageLength")
                  .col-12
                    label Width
                    br
                    input(required type="number" step=".0001" min="0" v-model="dimensions.cmPackageWidth")
                  .col-12
                    label Height
                    br
                    input(required type="number" step=".0001" min="0" v-model="dimensions.cmPackageHeight")
              .col-12
                label Package Declared Value (USD)
                br
                currency-input(v-model="insurance")
              .col-12
                label Merchandise Description
                br
                input(required v-model="returnMerchandiseDescription")
              .col-12.text-right
                button.btn.btn-primary() Submit

</template>

<script>

import { mapState, mapActions } from "vuex";
import convert from 'convert-units'
import moment from 'moment';
import Spinner from 'vue-simple-spinner'
export default {
  name: 'CreateReturnLabel',
  components:{
    Spinner
  },
  props: {    
    orderInfo:Object,
  },
  data:function(){
    return{
      loading:true,
      creatingLabel:false,
      order:null,
      addresses:null,
      address:'',
      dimensions:{
        packageLength:6,
        packageWidth:4,
        packageHeight:1,
        cmPackageLength:15,
        cmPackageWidth:10,
        cmPackageHeight:3
      },
      insurance:100,
      returnMerchandiseDescription:'',
      carrier:'',
    }
  },
  watch:{
    address: {      
      handler() {        
        localStorage.setItem('returnLabelAddress', JSON.stringify(this.address));        
      },
      deep: true,
    },
    carrier: {      
      handler() {        
        localStorage.setItem('returnLabelCarrier', JSON.stringify(this.carrier));        
      },
      deep: true,
    }
  },
  computed:{
    ...mapState(['allCarriers']),    
  },
  methods:{
    ...mapActions(['loadingOverlayChange']),
    async closeModal(){
      this.$emit('closeOrder');
    },
    async createReturnLabel(){
      this.loadingOverlayChange(true)
      this.flash('Shipping Carrier is generating the Return Label, please wait...', 'success', {timeout:7000})
      var bodyFormData = new FormData();

      if(this.address.company) bodyFormData.append('fromCompanyName',this.address.company)
      else bodyFormData.append('fromCompanyName',this.address.sender)

      bodyFormData.append('fromAttentionName', this.address.sender)
      bodyFormData.append('fromPhoneNumber', this.address.phone)
      bodyFormData.append('fromAddressLine1', this.address.address1)
      bodyFormData.append('fromAddressLine2', this.address.address2)
      bodyFormData.append('fromCity', this.address.city)
      bodyFormData.append('fromCountryCode', this.address.countryCode )
      bodyFormData.append('fromPostalCode', this.address.postalCode )
      if (this.address.countryCode === 'CA') {
        bodyFormData.append('fromStateProvinceCode', this.address.provinceCode)
      } else {
        bodyFormData.append('fromStateProvinceCode', this.address.stateCode)
      }

      

      if(this.address.company) bodyFormData.append('shipToCompanyName', this.address.company )
      else bodyFormData.append('shipToCompanyName', this.address.sender)

      bodyFormData.append('shipToAttentionName', this.address.sender )
      bodyFormData.append('shipToPhoneNumber', this.address.phone )
      bodyFormData.append('shipToAddressLine1', this.address.address1 )
      bodyFormData.append('shipToAddressLine2', this.address.address2)
      bodyFormData.append('shipToCity', this.address.city)
      // bodyFormData.append('shipToStateProvinceCode', this.address.stateCode)
      bodyFormData.append('shipToCountryCode', this.address.countryCode)
      bodyFormData.append('shipToPostalCode', this.address.postalCode)
      
      bodyFormData.append('shipFromCompanyName', this.order.company)
      bodyFormData.append('shipFromAttentionName', this.order.recipient)

      if (this.address.countryCode === 'CA') {
        bodyFormData.append('shipToStateProvinceCode', this.address.provinceCode)
      } else if(this.address.countryCode === 'US') {
        bodyFormData.append('shipToStateProvinceCode', this.address.stateCode)
      }else{
        bodyFormData.append('shipToStateProvinceCode', '')
      }
      
      if(this.order.phone) {
        bodyFormData.append('shipFromPhoneNumber', this.order.phone) 
      } else {
        bodyFormData.append('shipFromPhoneNumber', this.address.phone)
      }
      
      bodyFormData.append('shipFromAddressLine1', this.order.address1) 
      bodyFormData.append('shipFromAddressLine2', this.order.address2) 
      bodyFormData.append('shipFromCity', this.order.city) 
      bodyFormData.append('shipFromStateProvinceCode', this.order.stateProvinceCode) 
      bodyFormData.append('shipFromCountryCode', this.order.countryCode) 
      bodyFormData.append('shipFromPostalCode', this.order.postalCode) 
      if(this.countryCode =='US'){ 
        bodyFormData.append('orderWeight', this.order.lbsWeight)
        bodyFormData.append('packageLength', this.dimensions.packageLength) 
        bodyFormData.append('packageWidth', this.dimensions.packageWidth) 
        bodyFormData.append('packageHeight', this.dimensions.packageHeight) 
      }else{ 
        bodyFormData.append('orderWeight', this.order.kgWeight)
        bodyFormData.append('packageLength', this.dimensions.cmPackageLength) 
        bodyFormData.append('packageWidth', this.dimensions.cmPackageWidth) 
        bodyFormData.append('packageHeight', this.dimensions.cmPackageHeight) 
      }            
      bodyFormData.append('insurance', this.insurance) 
      bodyFormData.append('returnMerchandiseDescription', this.returnMerchandiseDescription) 
      bodyFormData.append('carrier', this.carrier) 
      bodyFormData.append('rma', this.order.rmaId) 
      bodyFormData.append('orderId', this.order._id)
      bodyFormData.append('selectedWarehouse', this.address._id)
      
      let response = await this.axios.post(`/rp/server/return/label`,bodyFormData)
      this.loadingOverlayChange(false)

      if(response.data.error){
        this.flash(response.data.error.message, 'error');
      }else{
        if(response.data.return.status == 'created'){
          this.flash(`Return Label ${response.data.return.status}`,'success')
          this.$router.push({path:`/dashboard/returns/${response.data.return._id}`})
        }
      }
    },
  },
  async mounted(){
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeOrder");
      }
    };
    this.order = this.orderInfo;
    let addresses = await this.axios.get(`/rp/server/return_address`)
    this.addresses = addresses.data;
    if(this.order.weight > 0){ 
      this.order.lbsWeight = Math.ceil(this.order.weight / 16 / 28.349)
      this.order.kgWeight = this.order.weight / 1000
    }else {
      this.order.lbsWeight = 1
      this.order.kgWeight = .1
    }
    
    if (localStorage.getItem('returnLabelAddress')) this.address = JSON.parse(localStorage.getItem('returnLabelAddress'));
    if (localStorage.getItem('returnLabelCarrier')) this.carrier = JSON.parse(localStorage.getItem('returnLabelCarrier'));
   
    this.loading = false;
  }
}
</script>

<style scoped lang="scss">
.closeForm{
    position:absolute;
    right:20px;
    top:20px;
  }
  .col-12{
    margin-bottom:20px
  }
  textarea{
    width:50%;
  }
  label{
    margin-bottom:0px;
    margin-top:10px;
  }
  input, select{
    min-width:250px;
  }
  .createReturnLabel{
    min-width:60vw;
  }
</style>
